import * as React from 'react';
import { NotificationsActive, Warning, Error } from 'emotion-icons/material';
import { Placeholder as Placeholder$2, IconWrapper, Message } from './Placeholder.styles.js';

var Placeholder = function Placeholder(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'success' : _ref$type,
    children = _ref.children;
  var Icon = /*#__PURE__*/React.createElement(NotificationsActive, null);
  if (type === 'warning') {
    Icon = /*#__PURE__*/React.createElement(Warning, null);
  } else if (type === 'error') {
    Icon = /*#__PURE__*/React.createElement(Error, null);
  }

  // TODO: A global config should determine what is "production"
  // TODO: should also log in production to some service
  return process.env.NODE_ENV !== 'production' ? /*#__PURE__*/React.createElement(Placeholder$2, {
    color: type
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    color: type
  }, Icon), /*#__PURE__*/React.createElement(Message, null, children)) : null;
};
var Placeholder$1 = Placeholder;

export { Placeholder$1 as default };
//# sourceMappingURL=index.js.map
